<template lang="pug">
validation-observer(ref="observer", v-slot="{ validateWithInfo }")
  v-container.the-my-account-form
    v-row.px-5
      template(v-if="holder.step == 1")
        v-col.pt-0(cols="12")
          .main-title.gokleenblue--text.text-uppercase My Account
        v-col.py-0(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }")
                  | Property Type
              v-col(cols="12", md="8")
                .py-2.px-1
                  validation-provider(mode="passive", name="property type", rules="required")
                    v-autocomplete(
                      v-model="item.property_type",
                      :items="listing.property_types",
                      item-text="name",
                      item-value="id",
                      solo,
                      flat,
                      hide-details,
                      @change="onPropertyTypeChange",
                      placeholder="Select Property Type")
        v-col.pt-5(cols="12", v-if="item.property_type")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Current Address
              v-col(cols="12", md="8")
                .py-2.px-1
                  v-data-table.elevation-1(
                    :headers="listing.address_headers",
                    :items="listing.address",
                    mobile-breakpoint="300",
                    hide-default-header,
                    hide-default-footer)
                    template(v-slot:no-data)
                      | No Address Registered
        v-col.pt-5(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | {{addr_id > 0 ? 'Address':'Register New Address'}}
              v-col(cols="12", md="8")
                .py-2.px-1
                  validation-provider(mode="passive", name="new address", rules="required")
                    v-textarea(v-model="item.address", label="ADDRESS", solo, flat, no-resize, rows="3", hide-details)
                  span.info-textarea-text.white--text Ex: 577, Jalan Pelita 3, Pelita Commercial Centre, 98000 Miri, Sarawak, Malaysia.
      template(v-if="holder.step == 0")
        v-col.py-0(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Your Contact Info
              v-col(cols="12", md="8")
                v-row.py-1(no-gutters)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(mode="passive", name="first name", rules="required")
                      v-text-field(v-model="item.first_name", label="FIRST NAME", solo, flat, hide-details)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(mode="passive", name="last name", rules="required")
                      v-text-field(v-model="item.last_name", label="LAST NAME", solo, flat, hide-details)
                  v-col.pa-1(cols="12", md="6")
                    validation-provider(mode="passive", name="mobile phone", rules="required")
                      v-text-field(v-model="item.contact", label="MOBILE PHONE NO.", solo, flat, hide-details)
                  v-col.pa-1(cols="12", md="6")
                    v-text-field(v-model="item.contact_other", label="OTHER PHONE NO.", solo, flat, hide-details)
                  v-col.pa-1(cols="12")
                    v-text-field(v-model="item.company_name", label="COMPANY NAME", solo, flat, hide-details)
        v-col.pt-5(cols="12")
          v-card.rounded-0(color="gokleenblue")
            v-row.px-2(no-gutters)
              v-col(cols="12", md="4")
                .servicetype-title.text-uppercase.white--text.px-2.pt-5(:class="{ 'text-center': breakpoint.lgAndUp }") 
                  | Current Address
              v-col(cols="12", md="8")
                .py-2.px-1
                  v-data-table.elevation-1(
                    :headers="listing.mainpage_address_headers",
                    :items="listing.address_original",
                    mobile-breakpoint="300",
                    hide-default-header,
                    hide-default-footer)
                    template(v-slot:item.address="{ item }")
                      .pa-1
                        span.mr-1 {{ item.address }}
                        v-chip
                          | {{ getPropertyTypeText(item.property_type) }}
                    template(v-slot:item.actions="{ item }")
                      v-icon.mt-0(small, @click="editAddress(item)")
                        | mdi-pencil
                    template(v-slot:no-data)
                      | No Address Registered
                    template(v-slot:body.append)
                      tr
                        td(colspan="2")
                          v-btn(block, @click="addNewAddress") Add New Address
      v-col(cols="12")
        v-row(no-gutters, justify="center")
          v-col.pa-2(cols="12", md="auto")
            v-btn(dark, x-large, block, rounded, color="primary", @click="validateWithInfo().then(submit)") SAVE
          v-col.pa-2(v-if="holder.step != 0", cols="12", md="auto")
            v-btn(dark, x-large, :block="isMobile", rounded, color="gokleenblue", @click="goOtherPage") 
              | Cancel
          v-col.pa-2(v-if="holder.step == 0", cols="12", md="auto")
            v-btn(dark, x-large, :block="isMobile", rounded, color="gokleenblue", @click="goHomePage") 
              | Close
</template>
<script>
import { DEFAULT_MYACCOUNT_VALUE } from "@/helpers/public/DefaultValue";
import ValidateMixins from "@/mixins/ValidateMixins.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import { WEBURL_PUBLIC } from "@/helpers/Url";
import axios from "@/plugins/axios";
export default {
  name: "TheMyAccount",
  mixins: [ValidateMixins],
  data: () => ({
    holder: {
      step: 0
    },
    listing: {
      mainpage_address_headers: [
        { text: "Name", align: "start", value: "address" },
        { text: "Actions", align: "end", value: "actions" }
      ],
      address_headers: [{ text: "name", align: "start", value: "name" }],
      property_types: [],
      address: [],
      address_original: []
    },
    item: Object.assign({}, DEFAULT_MYACCOUNT_VALUE),
    addr_id: 0,
    isBusy: false
  }),
  computed: {
    ...mapState("setting", ["Setting", "Currency", "UserInfo"]),
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("setting", ["initSetting"]),
    ...mapMutations("spinner", ["setSpinnerLoading"]),
    initialize() {
      this.item = Object.assign({}, this.item, DEFAULT_MYACCOUNT_VALUE);
      this.getTypes();
    },
    assignContactInfo() {
      let item = this.item;
      let loginUserInfo = this.UserInfo;
      // reset listing address everytime we try to get user contact info
      this.item.address = "";
      this.listing.address = [];
      this.listing.address_original = [];
      if (loginUserInfo) {
        item.company_name = loginUserInfo.companyname;
        item.first_name = loginUserInfo.firstname;
        item.last_name = loginUserInfo.lastname;
        item.contact = loginUserInfo.contact;
        item.contact_other = loginUserInfo.contact2;
        item.email = loginUserInfo.email;

        // check if address exist
        if (loginUserInfo.address) {
          let address = loginUserInfo.address;
          if (address && address.length > 0) {
            this.listing.address_original = address;
            this.assignAddressByPropertyType();
          }
        }
      }
      // trigger reactive
      this.item = Object.assign({}, this.item, item);
    },
    getPropertyTypeText(id) {
      let value = "";
      if (id >= 0) {
        let selected = this.listing.property_types.find(x => x.id == id);
        if (selected) {
          value = selected.name;
        }
      }
      return value;
    },
    getTypes() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      axios
        .get(WEBURL_PUBLIC.getMyAccountSetting)
        .then(res => {
          let data = res.data;
          if (data.property_types && data.property_types.length > 0) {
            this.listing.property_types = data.property_types;
          }

          this.assignContactInfo();
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    submit(resp) {
      if (resp.isValid) {
        let param = {
          items: Object.assign({}, this.item)
        };
        if (this.holder.step == 0) {
          // remove unused variable
          delete param.items.address;
          delete param.items.property_type;

          return this.save(WEBURL_PUBLIC.saveMyAccountSettingInfo, param);
        } else if (this.holder.step == 1) {
          // remove unused variable
          delete param.items.company_name;
          delete param.items.first_name;
          delete param.items.last_name;
          delete param.items.contact;
          delete param.items.contact_other;

          // add custom variable for address
          param.addr_id = this.addr_id;

          return this.save(WEBURL_PUBLIC.saveMyAccountSettingAddress, param);
        }
      }
      let errors = resp.errors;
      if (errors) {
        for (const key in errors) {
          if (errors[key].length > 0) {
            this.$eventHub.$emit("on-show-snackbar", {
              message: JSON.stringify(errors[key][0]),
              color: "error",
              position: {
                top: true
              },
              timeout: 10000
            });
            break;
          }
        }
        this.onErrorFocus("observer");
      }
    },
    addNewAddress() {
      // new address id
      this.addr_id = 0;
      this.item.property_type = null;
      this.item.address = null;
      this.listing.address = [];
      this.goOtherPage();
    },
    editAddress(obj) {
      // new address id
      this.addr_id = obj.id;
      this.item.address = obj.address;
      this.item.property_type = null;
      this.listing.address = [];
      // check for valid property type
      if (obj.property_type >= 0) {
        let selected = this.listing.property_types.find(x => x.id == obj.property_type);
        if (selected) {
          this.item.property_type = selected.id;
          this.onPropertyTypeChange();
        }
      }
      this.goOtherPage();
    },
    goOtherPage() {
      if (this.holder.step == 0) {
        this.holder.step = 1;
      } else {
        this.holder.step = 0;
      }
    },
    save(url, param) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.setSpinnerLoading(true);

      axios
        .post(url, param)
        .then(res => {
          if (res.data) {
            let data = JSON.parse(res.data.d);
            if (data) {
              this.$eventHub.$emit("on-show-snackbar", {
                message: data.message,
                color: data.status ? "blue" : "error",
                timeout: -1,
                position: {
                  top: true
                }
              });

              // only proceed if success
              if (data.status) {
                return this.initSetting()
                  .then(() => {
                    // reset item first before replace new
                    this.assignContactInfo();

                    this.isBusy = false;
                    this.setSpinnerLoading(false);
                    this.goOtherPage();
                  })
                  .catch(() => {
                    this.isBusy = false;
                    this.setSpinnerLoading(false);
                    this.goOtherPage();
                  });
              }
            }
          }
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    goHomePage() {
      this.$emit("goHomePage");
    },
    onPropertyTypeChange() {
      return this.assignAddressByPropertyType();
    },
    assignAddressByPropertyType() {
      this.listing.address = [];
      // by default , we alway select first address (if property type already selected)
      if (this.item.property_type > 0) {
        this.listing.address = this.listing.address_original
          .filter(x => x.property_type == this.item.property_type)
          .sort((a, b) => a.order - b.order)
          .map((item, index) => ({
            idx: index,
            name: item.address,
            property_type: item.property_type,
            order: item.order
          }));
      }
    }
  }
};
</script>
<style lang="scss">
.the-my-account-form {
  .main-title {
    font-weight: 700;
    font-size: 22px;
  }
  .info-text,
  .info-text label {
    font-size: 14px;
  }
  .signin-btn {
    font-weight: 600;
    display: inline-block;
    cursor: pointer;
  }
  .reminder-checkbox {
    i,
    label {
      color: #1572b6;
    }
  }
  .info-textarea-text {
    font-size: 12px;
    font-weight: 500;
  }
  input:disabled,
  textarea:disabled {
    color: rgba(100, 95, 95, 0.8);
  }
  hr {
    background: #1572b6;
    border-top: 1px solid;
  }
  .transparent-input {
    input,
    textarea,
    i,
    .v-text-field__prefix {
      color: #1572b6;
    }
    > .v-input__control > .v-input__slot {
      background: rgba(255, 255, 255, 0);
    }
  }
  .input-right-align {
    input {
      text-align: right;
    }
  }
  .inline-block {
    display: inline-block;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .header-info {
    display: flex;
    justify-content: space-between;
  }
  .session_input .v-input__control {
    min-height: 20px;
  }
  .session_input .v-input__control .v-input__slot,
  .session_input .v-text-field input {
    padding: 0 !important;
    font-size: 14px;
  }
}
</style>
